export default __webpack_public_path__ + "static/media/saarWaterfall.9688b37d.jpg";